import React from "react";
import PropTypes from "prop-types";
import OverStore, { optionTypes } from "data/OverStore";
import useFluxStore from "@armus/use-flux-store";

export class OverComponent extends React.Component {
    constructor(props) {
        super(props);
        this.alertTitleInterval = null;
        this.documentTitle = "";
        this.startTitleAlertInterval = this.startTitleAlertInterval.bind(this);
        this.endTitleAlertInterval = this.endTitleAlertInterval.bind(this);
        this.alertTitleToggle = this.alertTitleToggle.bind(this);
    }
    componentDidUpdate() {
        const {options} = this.props;
        // always try to refocus the first action on update.
        this.focusActionBtn(this.firstActionRef);
        if(!options) {
            this.endTitleAlertInterval();
            return;
        }
        const actions = options.actions || [];
        if(actions.length > 1) {
            this.startTitleAlertInterval();
        }
        else {
            this.endTitleAlertInterval();
        }
    }

    componentWillUnmount() {
        this.endTitleAlertInterval();
    }

    startTitleAlertInterval() {
        if(this.alertTitleInterval) {
            // already blinking
            return;
        }
        if(!this.documentTitle && document.title) {
            this.documentTitle = document.title;
        }
        // TODO: Play Sound here maybe?
        //
        // Start an interval to toggle the window title.
        // eslint-disable-next-line no-settimeout
        this.alertTitleInterval = setInterval(this.alertTitleToggle, 600);
    }

    endTitleAlertInterval() {
        if(this.alertTitleInterval) {
            clearInterval(this.alertTitleInterval);
            this.alertTitleInterval = null;
            document.title = this.documentTitle;
        }
    }

    alertTitleToggle() {
        // blinks the title bar text
        if(document.title !== this.documentTitle) {
            document.title = this.documentTitle;
        }
        else {
            document.title = "** Attention **";
        }
    }

    focusActionBtn(ActionRef) {
        if (ActionRef) ActionRef.focus();
    }

    onActionClick(e, action) {
        const {options, onHide} = this.props;
        if (options.autoHide) {
            onHide(options.key);
        }
        if (action.callback) action.callback();
    }

    onActionKeyDown(e, action) {
        if(e.keyCode === action.keyCode) {
            this.onActionClick(e, action);
        }
        if(e.keyCode === 9) {
            // prevent the user from tabbing out of the AlertModal
            if (e.target === this.lastActionRef && !e.shiftKey) {
                // last action - tab
                this.focusActionBtn(this.firstActionRef);
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            else if (e.target === this.firstActionRef && e.shiftKey) {
                // first action - shift+tab
                this.focusActionBtn(this.lastActionRef);
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        }
    }

    render() {
        const {options} = this.props;
        if(!options) { // no active modal on the stack.
            /* todo:
               this dummy container is only for AppDriver visibility check...
               It would be much gooder to just return null.
             */
            return (
                <div className={`loading-modal`} style={{display: "none"}}>
                    <div className="loading-box" />
                </div>
            );
        }
        this.firstActionRef = undefined;
        this.lastActionRef = undefined;
        if (process.env.NODE_ENV === "development") {
            if (typeof options.message === "string" && options.message.indexOf(">") >= 0) {
                console.warn("An over using an HTML string detected. Prefer a React render function.");
            }
        }
        const Message = typeof options.message === "function"
            ? options.message
            : () => options.message && options.message.indexOf(">") >= 0
                ? <div dangerouslySetInnerHTML={{__html: options.message}} />
                : <p>{options.message}</p>;
        let hasActions = false;
        let ui;
        if (options.messageIsUi) {
            ui = <Message />;
        } else {
            const actions = options.actions;
            let Actions = null;
            if (typeof actions === "function") {
                hasActions = true;
                Actions = actions;
            } else if (actions) {
                hasActions = actions.length > 0;
                Actions = () => actions.map((action, index) => (
                    <input
                        ref={(refAction) => {
                            if (index === 0) {
                                this.firstActionRef = refAction;
                            }
                            if (index === actions.length - 1) {
                                this.lastActionRef = refAction;
                            }
                        }}
                        key={index}
                        type="button"
                        id={"modal-action-" + index}
                        className="btn"
                        onClick={(e) => this.onActionClick(e, action)}
                        onKeyDown={(e) => this.onActionKeyDown(e, action)}
                        value={action.label}
                    />),
                );
            }
            ui = <React.Fragment>
                {options.title && <header>
                    <h4 className="title">{options.title}</h4>
                </header>}
                <div className="loading-body">
                    <Message />
                </div>
                {options.spinner && <img src="images/waiting.svg" alt="Loading..." />}
                {Actions && <div className="loading-modal-actions">
                    <Actions />
                </div>}
            </React.Fragment>;
        }

        return (
            <div className={`loading-modal ${options.title ? "title-bar" : ""} ${hasActions ? "interactive" : ""}`} onClick={() => this.focusActionBtn(this.firstActionRef)}>
                <div className="loading-box">
                    {ui}
                </div>
            </div>
        );

    }
}

OverComponent.propTypes = {
    options: optionTypes,
    onHide: PropTypes.func.isRequired
};

const OverModal = props => {
    const state = useFluxStore(() => ({
        options: OverStore.getActiveItem(),
    }), [
        OverStore,
    ]);
    return <OverComponent {...props} {...state} />;
};

export default OverModal;




// WEBPACK FOOTER //
// ./app/lib/over/OverModal.js